import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { updateReceiveEmail } from '../../../state/actions/updateDataActions'
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Hidden,
} from '@material-ui/core';
import { API_ROOT } from '../../../baseUrls';
import { Alert } from '@material-ui/lab';

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class ReceiveEmail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSuccess: false,
      receiveEmailMode: 'display'
    }
  }

  updateReceiveEmail() {
    const formData = new FormData()
    formData.append("user[receive_email]", this.props.user.receive_email)
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${API_ROOT}/users/${ this.props.user.uid }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({ receiveEmailMode: 'display', showSuccess: true })
      }
    })
    .catch(error => console.error(error))
  }

  renderReceiveEmailDisplay() {
    return (
      <Box>
        { this.state.showSuccess ?<Box style={{marginBottom: "1rem"}}> <Alert onClose={ () => this.setState({ showSuccess: false }) }>Receive email option was updated.</Alert></Box> : '' }
        <Hidden mdUp>
          <Box pb={2}><Typography>Password</Typography></Box>
        </Hidden>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Hidden smDown>
            <Box><Typography>Receive email</Typography></Box>
          </Hidden>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography>{ this.props.user.receive_email ? 'Yes' : 'No' }</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ receiveEmailMode: 'form' }) }>Update</Button>
        </div>
      </Box>
    )
  }

  renderReceiveEmailForm(classes) {
    return(
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Account
        </Typography>
        <Box className={ classes.fieldWrapper }>
          <FormControl component="fieldset">
            <FormLabel component="legend">Receive email</FormLabel>
            <RadioGroup
              name="receive-email"
              value={ this.props.user.receive_email ? 'yes' : 'no' }
              onChange={ evt => this.props.updateReceiveEmail(evt.target.value === 'yes') }
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updateReceiveEmail.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="default" onClick={ () => this.setState({ receiveEmailMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.receiveEmailMode === 'display') ? this.renderReceiveEmailDisplay(classes) : this.renderReceiveEmailForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
  }
}

const mapDispatchToProps = {
  updateReceiveEmail,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ReceiveEmail))
